export const FETCH_TEACHERS="FETCH_TEACHERS_FOR_JOURNAL";